export const AMO_API_URL = `${process.env.BASE_URL}/v1`;

export const MODAL_NAMES = {
  document: 'document',
  start: 'start',
  navigation: 'navigation',
  auth: 'auth',
};

export const DOCUMENT_MODAL_TYPES = {
  agreement: 'agreement',
  security: 'security',
  confidence: 'confidence',
};

export const JS_CLASS_NAMES = {
  withPreventScrollOffset: 'js-scroll-preventable',
  withPreventScrollTouch: 'js-scroll-touch',
};

export const DOCUMENT_URL_PARAM_KEY = 'document';

export const URLS = {
  cases: 'https://www.amocrm.ru/cases',
  amostart: 'https://amostart.ru/',
  apiDocks: 'https://www.amocrm.ru/developers/content/crm_platform/platform-abilities',
};

export const CRM_PLUGIN_SCRIPT = 
  `(function(a,m,o,c,r,m){a[m]={id:"431043",hash:"2c64862cfd787f0ed0c56e20f4389619d1db4c7fbfd685911251303454c61550",
  locale:"ru",inline:false,setMeta:function(p){this.params=(this.params||[]).concat([p])}};
  a[o]=a[o]||function(){(a[o].q=a[o].q||[]).push(arguments)};var d=a.document,s=d.createElement('script');
  s.async=true;s.id=m+'_script';s.src='https://gso.amocrm.ru/js/button.js';
  d.head&&d.head.appendChild(s)}(window,0,'amoSocialButton',0,0,'amo_social_button'));`;
